import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Settings } from 'lucide-react';
import CustomAppBar from '../../../mainComponents/appBar';
import { useUserUpdateMutation } from '../../../redux/setting';
import toast from "react-hot-toast";

export default function Filtering() {
  const navigate = useNavigate();
  const [filtering, setFiltering] = useState(() => {
    return localStorage.getItem('advancedFiltering') === 'true';
  });

  const [updateNotificationSettings, { isLoading }] = useUserUpdateMutation();

  const handleToggle = async () => {
    const newValue = !filtering;

    try {
      const response = await updateNotificationSettings({
        
        filter_message: true
      }).unwrap();

      toast.success(response.message || "User Settings updated successfully");

      setFiltering(newValue);
      localStorage.setItem('advancedFiltering', newValue.toString());
    } catch (error) {
      console.error('Failed to update notification settings:', error);
      toast.error("Failed to update settings.");
    }
  };

  return (
    <div className="flex justify-center bg-[#f5f5f5] overflow-hidden no-scrollbar pt-10 h-screen px-4 py-6 text-black font-[SF Pro Display]">
      <div className="w-full max-w-sm">
        {/* Header */}
        <CustomAppBar title="Message Filtering" />

        {/* Card */}
        <div className="bg-white rounded-2xl mt-5 p-6 text-center shadow-md space-y-4">
          <div className="flex justify-center">
            <div className="bg-purple-100 p-4 rounded-full">
              <Settings className="w-6 h-6 text-purple-600" />
            </div>
          </div>
          <h2 className="text-lg font-bold">
            {filtering ? 'Filtering is ON 🔐' : 'Filtering is OFF 🚫'}
          </h2>
          <p className="text-sm text-gray-600">
            {filtering
              ? 'Inappropriate messages will be hidden automatically.'
              : 'All messages will appear in your inbox — even the spicy ones 👀.'}
          </p>

          <div className="flex justify-center pt-2">
            <label className="inline-flex items-center cursor-pointer">
              <input
                type="checkbox"
                className="sr-only"
                checked={filtering}
                onChange={handleToggle}
                disabled={isLoading}
              />
              <div
                className={`w-11 h-6 ${
                  filtering ? 'bg-purple-500' : 'bg-gray-300'
                } rounded-full relative transition duration-200`}
              >
                <div
                  className={`absolute top-1 left-1 w-4 h-4 bg-white rounded-full shadow-md border transition-transform duration-200 ${
                    filtering ? 'translate-x-5' : ''
                  }`}
                ></div>
              </div>
            </label>
          </div>
        </div>
      </div>
    </div>
  );
}
